<template>
    <div class="class-list p-b-64 page" style="font-size: 14px">
        <van-tabs v-model="active" color="#3388ff" :sticky="true">
            <van-tab title="我已审批">
                <approveList :type="'1-1'" :isChoice="true" :selected="selectedIds" v-on:select="onSelect"
                             :search="search"
                             v-on:disSelect="onDisSelect"></approveList>
            </van-tab>
            <van-tab title="我发起的">
                <approveList :type="'2'" :isChoice="true" :selected="selectedIds" v-on:select="onSelect"
                             :search="search"
                             v-on:disSelect="onDisSelect"></approveList>
            </van-tab>
            <van-tab title="抄送我的">
                <approveList :type="'3-0'" :isChoice="true" :selected="selectedIds" v-on:select="onSelect"
                             :search="search"
                             v-on:disSelect="onDisSelect"></approveList>
            </van-tab>
        </van-tabs>
        <div class="m-l-12 m-r-12" style="position: fixed; bottom: 12px; left: 0px; right: 0px; ">
            <van-button
                style="background-color: #3388ff; color: white; width: 100%; border: 0px transparent solid; border-radius: 3px"
                @click.native="commit">确定
            </van-button>
        </div>
    </div>
</template>

<script>
    import head from '../../mixins/head';
    import approveList from './listCompnent';

    export default {
        components: {
            approveList
        },
        name: 'approve-choice',
        mixins: [head],
        data() {
            return {
                active: 1,
                selectedData: [],
                selectedIds: [],
                search: {
                    type: '',
                    content: '',
                    status: ''
                }
            };
        },
        props: {},
        watch: {},
        computed: {},
        created() {
            if (window.tempRelate.availableTemplates) {
                let a = '';
                for (let i = 0; i < window.tempRelate.availableTemplates.length; i++) {
                    let id = window.tempRelate.availableTemplates[i].id;
                    //TODO 处理客来福合作伙伴展厅关联审批单无法选择的问题，1个月后删除，2019年5月13日
                    if (id == 9618) {
                        id = 19355;
                    }
                    if (i > 0) {
                        a += ',';
                    }
                    a += id;
                }
                this.search.type = a;
            }
        },
        mounted() {
        },
        methods: {
            onSelect(data) {
                let exist = false;
                for (let i = 0; i < this.selectedData.length; i++) {
                    if (this.selectedData[i].id == data.id) {
                        exist = true;
                        break;
                    }
                }
                if (!exist) {
                    this.selectedData.push(data);
                    this.selectedIds.push(data.id);
                }
            },

            onDisSelect(data) {
                for (let i = 0; i < this.selectedData.length; i++) {
                    if (this.selectedData[i].id == data.id) {
                        this.selectedData.splice(i, 1);
                        this.selectedIds.splice(i, 1);
                        break;
                    }
                }
            },

            commit() {
                let a = [];
                for (let i = 0; i < this.selectedData.length; i++) {
                    let item = this.selectedData[i];
                    a.push({
                        id: item.id,
                        title: item.approveName,
                        statusCd: item.statusCd,
                        approveType: item.approveType
                    });
                }
                window.tempRelate.data = a;
                console.log('commit', window.tempRelate);
                this.GO(-1);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .van-tabs__content {
        padding-bottom: 68px;
    }
</style>
